import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AuthenticationInterceptor } from './authentication.interceptor';
import { NeqHttpClient } from './http-client.config';
import { LangServiceClient, LoggerServiceClient } from './technical.restservice';
import {
  ClassNutrientServiceClient,
  CoherenceEquationServiceClient,
  ComputeServiceClient,
  DomainRightNutrientServiceClient,
  DomainRightPredictionModelServiceClient,
  DomainRightReferenceServiceClient,
  EntityServiceClient as DataEntityServiceClient,
  LevelServiceClient,
  NutrientServiceClient,
  PredictionModelServiceClient,
  ReferenceServiceClient,
  SubClassNutrientTranslateServiceClient,
  SubClassServiceClient,
  SubLevelTranslateServiceClient,
  SubNutrientRightServiceClient,
  SubNutrientTranslateServiceClient,
  SubPredictionModelRightServiceClient,
  SubPredictionModelTranslateServiceClient,
  SubReferenceRightServiceClient,
  SubReferenceTranslateServiceClient,
  TechnicalServiceClient as DataTechnicalServiceClient,
  VariableValueServiceClient,
  SubNutrientPredictionModelServiceClient,
  ResultColumnService,
  FullAutoImportService,
  SemiAutoImportHttpService,
  DataSampleNutrientService,
  SampleResultService,
  RawMaterialService,
  DataSampleTempCalculationServiceClient,
  DataSampleBulletinServiceClient
} from './data.restservice';
import {
  RightDescriptionServiceClient,
  SubEntityServiceClient,
  SubRoleServiceClient,
  SubUserServiceClient,
  TechnicalMetaServiceClient,
  UserServiceClient as UserIdentityServiceClient,
  UserServiceClient,
  EntityTypeServiceClient
} from './identity.restservice';
import {
  ClassServiceClient,
  ClassVariableServiceClient,
  DomainRightMatrixServiceClient,
  EntityServiceClient as EquationEntityServiceClient,
  EquationServiceClient,
  MatrixServiceClient,
  VariableServiceClient
} from './equation.restservice';
import { EquationManagerServiceClient } from './equation-manager.restservice';
import { CustomDataServiceClient } from '@sharedrest/data-custom.restservice';
import {BlobErrorHttpInterceptor} from '@sharedrest/blob-error.interceptor';
import {CustomEquationServiceClient} from '@sharedrest/equation-custom.restservice';

const sharedServices = [ NeqHttpClient, LoggerServiceClient,
  VariableServiceClient, MatrixServiceClient, EquationServiceClient, ClassServiceClient, ClassVariableServiceClient,
  EquationManagerServiceClient, EquationEntityServiceClient, UserServiceClient, LangServiceClient, DataSampleBulletinServiceClient,
  RightDescriptionServiceClient, TechnicalMetaServiceClient, UserIdentityServiceClient, DataTechnicalServiceClient,
  CustomDataServiceClient, DataEntityServiceClient, SubEntityServiceClient, EntityTypeServiceClient, SubRoleServiceClient, SubUserServiceClient,
  ClassNutrientServiceClient, SubClassServiceClient, SubClassNutrientTranslateServiceClient, LevelServiceClient,
  SubLevelTranslateServiceClient, NutrientServiceClient, SubNutrientTranslateServiceClient, SubNutrientRightServiceClient,
  PredictionModelServiceClient, SubPredictionModelTranslateServiceClient, SubPredictionModelRightServiceClient,
  ReferenceServiceClient, SubReferenceTranslateServiceClient, SubReferenceRightServiceClient, CoherenceEquationServiceClient,
  VariableValueServiceClient, ComputeServiceClient, DomainRightMatrixServiceClient, DomainRightReferenceServiceClient,
  ResultColumnService, FullAutoImportService, DataSampleNutrientService, SampleResultService, RawMaterialService,
  DomainRightPredictionModelServiceClient, DomainRightNutrientServiceClient, CustomEquationServiceClient, SubNutrientPredictionModelServiceClient, SemiAutoImportHttpService,
  DataSampleTempCalculationServiceClient
];


@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  providers: [
    ...sharedServices,
    { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BlobErrorHttpInterceptor, multi: true }
  ],
})
export class CommonRestModule {

}
